export default defineNuxtRouteMiddleware((to, from) => {
  if (process.client && to.path !== from.path) {
    const notificationsStore = useNotificationsStore()
    notificationsStore.clearNonPersistentNotifications()
  }
})
